"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Product = void 0;
/**
 * Product description. <br/>
 * We will present the data from this object on the website to end users.
 * The object describes the recommended product.
 * The data contained in the product is the data from the catalog transferred to the Quarticon system
 */
var Product = /** @class */ (function () {
    /** @ignore */
    function Product(params) {
        this._id = params.id;
        this._pageUrl = params.pageUrl;
        this._imageUrl = params.imageUrl;
        this._price = params.price;
        this._priceOld = params.priceOld;
        this._title = params.title;
        this._custom = params.custom;
    }
    Object.defineProperty(Product.prototype, "id", {
        /** Product identifier */
        get: function () {
            return this._id;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(Product.prototype, "pageUrl", {
        /** Product page url */
        get: function () {
            return this._pageUrl;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(Product.prototype, "imageUrl", {
        /** Product image link */
        get: function () {
            return this._imageUrl;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(Product.prototype, "price", {
        /** Product price */
        get: function () {
            return this._price;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(Product.prototype, "priceOld", {
        /** Product old price */
        get: function () {
            return this._priceOld;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(Product.prototype, "title", {
        /** Product title */
        //ts-ignore
        get: function () {
            return this._title;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(Product.prototype, "custom", {
        /** Product additional custom data */
        get: function () {
            return this._custom;
        },
        enumerable: false,
        configurable: true
    });
    /** @ignore */
    Product.createFromResponse = function (requestProduct) {
        var _a, _b, _c, _d;
        var custom = [];
        if (requestProduct.custom_1) {
            custom.push({ name: '1', value: requestProduct.custom_1 });
        }
        if (requestProduct.custom_2) {
            custom.push({ name: '2', value: requestProduct.custom_2 });
        }
        if (requestProduct.custom_3) {
            custom.push({ name: '3', value: requestProduct.custom_3 });
        }
        if (requestProduct.custom_4) {
            custom.push({ name: '4', value: requestProduct.custom_4 });
        }
        var params = {
            id: requestProduct.id,
            pageUrl: requestProduct.link,
            imageUrl: (_a = requestProduct.image) !== null && _a !== void 0 ? _a : '',
            price: (_b = requestProduct.price) !== null && _b !== void 0 ? _b : '',
            priceOld: (_c = requestProduct.old_price) !== null && _c !== void 0 ? _c : '',
            custom: custom,
            title: (_d = requestProduct.title) !== null && _d !== void 0 ? _d : ''
        };
        return new Product(params);
    };
    return Product;
}());
exports.Product = Product;
//# sourceMappingURL=Product.js.map